@if (showAdminShell()) {
  <div class="h-screen overflow-hidden text-slate-800">
    <app-sidebar [isOpen]="isSidebarOpen()" (closeSidebar)="onCloseSidebar()" />

    <button
      type="button"
      class="fixed top-[25px] z-[70] hidden size-5 -translate-y-1/2 items-center justify-center rounded-full border-0 bg-slate-200/60 text-black outline-none transition-all duration-300 ease-in-out hover:bg-slate-300 focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 active:outline-none lg:inline-flex"
      [ngClass]="{
        'left-[calc(300px-0.625rem)]': isSidebarOpen(),
        'left-[calc(4rem-0.625rem)]': !isSidebarOpen(),
      }"
      (click)="onToggleSidebar()"
      [attr.aria-expanded]="isSidebarOpen()"
      aria-controls="admin-sidebar"
      aria-label="Alternar sidebar"
    >
      <span class="sr-only">Alternar sidebar</span>

      <i
        class="bi text-[0.65rem] leading-none"
        [class.bi-chevron-right]="!isSidebarOpen()"
        [class.bi-chevron-left]="isSidebarOpen()"
        aria-hidden="true"
      ></i>
    </button>

    @if (isSidebarOpen()) {
      <div
        class="fixed inset-0 z-50 bg-slate-900/40 backdrop-blur-sm transition-opacity lg:hidden"
        (click)="onToggleSidebar()"
        aria-hidden="true"
      ></div>
    }

    <div
      class="relative flex h-full flex-col transition-all duration-300"
      [ngClass]="{
        'lg:ms-[300px]': isSidebarOpen(),
        'lg:ms-16': !isSidebarOpen(),
      }"
    >
      <app-header
        [sidebarCollapsed]="!isSidebarOpen()"
        [applicationTitle]="'Área administrativa'"
        (toggleSidebar)="onToggleSidebar()"
        (logout)="onLogout()"
      />

      <main class="mt-[50px] min-h-0 flex-1 overflow-y-auto overscroll-contain p-6">
        <router-outlet />
      </main>
    </div>
  </div>
} @else {
  <div class="min-h-screen text-slate-800">
    @if (showAuthRedirectPreloader()) {
      <div class="flex min-h-screen items-center justify-center px-4">
        <app-admin-preloader message="Redirecionando para autenticação" variant="inline" />
      </div>
    }

    <router-outlet [class.hidden]="showAuthRedirectPreloader()" />
  </div>
}
